module.exports = __webpack_public_path__ + "images/buttons/btn-playstore-2.db9b21a1c41f3dcd9731.png";